import { render, staticRenderFns } from "./no-groups-found.vue?vue&type=template&id=5e5bd923&"
import script from "./no-groups-found.vue?vue&type=script&lang=js&"
export * from "./no-groups-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports